/**
 * Whether a scheduler calendar event represents booked time off.
 */
export const isSchedulerTimeOffEvent = (event) => {
  if (!event) return false;
  if (event.status === 'time_off') return true;
  if (event.time_off_category_id) return true;
  if (event.time_off_category?.id) return true;

  return false;
};
